// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasRectangleWide: CreateIconOptions = {
  "displayName": "FASRectangleWide",
  "viewBox": "0, 0, 640, 512",
  "d": "M0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
};
